export const FEDINFO_FEATURE_LABEL = {
    INTERNAL_ORDER_LABEL: 'INTERNAL_ORDER',
    WBS_LABEL: 'SHOW_WBS',
    BILLING_CODE_DROPDOWN: 'BILLING_CODE_DROPDOWN',
    DELIVERY_COMMENTS_LABEL: 'SHOW_DELIVERY_COMMENTS',
    ORDER_COMMENTS_LABEL: 'ORDERCOMMENT_LABEL',
    ORDER_NOTES_LABEL: 'SHOW_ORDER_NOTES',
    PRODUCT_CODE_LABEL: 'PRODUCT_CODE_LABEL',
    ON_DEMAND_LABEL: 'ON_DEMAND_LABEL',
    ON_DEMAND_ORDERS_LABEL: 'ONDEMANDORDERS_LABEL',
    ORDER_WINDOW_LABEL: 'ORDER_WINDOW_LABEL',
    ORDER_WINDOW_ORDERS_LABEL: 'ORDERWINDOWORDERS_LABEL',
    PLANNING_COMMENTS_LABEL: 'PLANNINGCOMMENTS_LABEL'
};